import { LoadingService } from './../../../util/loader.service';
import { ColorsService } from './../../../shared/colors/colors.service';
import { DashboardService } from './dashboard.service';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { Chart } from 'chart.js';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { DashboardUsuarioViewModel } from '../../../models/dashboard/dashboardUsuarioViewModel';

import { ChartType, ChartOptions } from 'chart.js';
import { ComparacaoPontuacaoAno } from '../../../models/dashboard/ComparacaoPontuacaoAno';
import { BaseChartDirective } from 'ng2-charts';



@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DashboardComponent implements OnInit {
  bestscustomers = [];
  piecharts = [];
  empresasPorEstado = [];
  pontuacoesPorMes = [];
  pontuacoesPorAno = [];
  comparacaoDeEmperesasCadastradaPorAno: ComparacaoPontuacaoAno;
  comparacoesDePontuacoePorAno: ComparacaoPontuacaoAno;
  monthNames = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
    "Jul", "Ago", "Set", "Out", "Nov", "Dez"
  ];
  meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ];
  nameMonth;
  nameYaer;
  resumo = {
    total_cliente: 0,
    total_cliente_recorrente: 0,
    total_cliente_naorecorrente: 0,
    total_pontuacao: 0,
    total_cartao_incompleto: 0,
    total_cartao_completo: 0,
    total_cartao: 0,
    total_proximo_bonificar: 0,
    total_faturamento_ano: 0,
    total_faturamento_mes: 0,
    total_faturamento_dia: 0,
    ticket_medio_mensal: 0,
  };
  pieData = {
    labels: [],
    datasets: [{
      data: []
    }]
  };
  pieColors = [{
    borderColor: [
    ],
    backgroundColor: [],
  }];
  pieOptions = {
    responsive: true
  };

  pieDataEmpresaPorEstado = {
    labels: [],
    datasets: [{
      data: []
    }]
  };
  pieColorsEmpresaPorEstado = [{
    borderColor: [
    ],
    backgroundColor: [],
  }];
  pieOptionsEmpresaPorEstado = {
    responsive: true
  };

  barData: any;
  public barOptions = {
    series: {
      bars: {
        align: 'center',
        lineWidth: 0,
        show: true,
        barWidth: 0.6,
        fill: 0.9
      }
    },
    grid: {
      borderColor: '#eee',
      borderWidth: 1,
      hoverable: true,
      backgroundColor: '#fcfcfc'
    },
    tooltip: true,
    tooltipOpts: {
      content: function (label, x, y) { return x + ' : ' + y; }
    },
    xaxis: {
      tickColor: '#fcfcfc',
      mode: 'categories'
    },
    yaxis: {
      // position: ($scope.app.layout.isRTL ? 'right' : 'left'),
      tickColor: '#eee'
    },
    shadowSize: 0
  };


  barDataDotForYear: any;
  public barOptionsDotForYear = {
    series: {
      bars: {
        align: 'center',
        lineWidth: 0,
        show: true,
        barWidth: 0.6,
        fill: 0.9
      }
    },
    grid: {
      borderColor: '#eee',
      borderWidth: 1,
      hoverable: true,
      backgroundColor: '#fcfcfc'
    },
    tooltip: true,
    tooltipOpts: {
      content: function (label, x, y) { return x + ' : ' + y; }
    },
    xaxis: {
      tickColor: '#fcfcfc',
      mode: 'categories'
    },
    yaxis: {
      // position: ($scope.app.layout.isRTL ? 'right' : 'left'),
      tickColor: '#eee'
    },
    shadowSize: 0
  };
  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;
  splineData: any;
  splineOptions = {
    series: {
      lines: {
        show: false
      },
      points: {
        show: true,
        radius: 4
      },
      splines: {
        show: true,
        tension: 0.4,
        lineWidth: 1,
        fill: 0.5
      }
    },
    grid: {
      borderColor: '#eee',
      borderWidth: 1,
      hoverable: true,
      backgroundColor: '#fcfcfc'
    },
    tooltip: true,
    tooltipOpts: {
      content: function (label, x, y) { return x + ' : ' + y; }
    },
    xaxis: {
      tickColor: '#fcfcfc',
      mode: 'categories'
    },
    yaxis: {
      min: 0,
      max: 150, // optional: use it for a clear represetation
      tickColor: '#eee',
      // position: (app.layout.isRTL ? 'right' : 'left'),
      tickFormatter: function (v) {
        return v/* + ' visitors'*/;
      }
    },
    shadowSize: 0
  };

  splineDataCompanyRegisterYaer: any;
  splineOptionsCompanyRegisterYaer = {
    series: {
      lines: {
        show: false
      },
      points: {
        show: true,
        radius: 4
      },
      splines: {
        show: true,
        tension: 0.4,
        lineWidth: 1,
        fill: 0.5
      }
    },
    grid: {
      borderColor: '#eee',
      borderWidth: 1,
      hoverable: true,
      backgroundColor: '#fcfcfc'
    },
    tooltip: true,
    tooltipOpts: {
      content: function (label, x, y) { return x + ' : ' + y; }
    },
    xaxis: {
      tickColor: '#fcfcfc',
      mode: 'categories'
    },
    yaxis: {
      min: 0,
      max: 150, // optional: use it for a clear represetation
      tickColor: '#eee',
      // position: (app.layout.isRTL ? 'right' : 'left'),
      tickFormatter: function (v) {
        return v/* + ' visitors'*/;
      }
    },
    shadowSize: 0
  };

  constructor(
    public colors: ColorsService,
    public http: HttpClient,
    public service: DashboardService,
    public loader: LoadingService,
    private _localeService: BsLocaleService,
    private formBuilder: FormBuilder
  ) {

    this._localeService.use('pt');

    this.formBuilder.group({
      empresaNome: [null, Validators.required],
      dataInicio: [null, null],
      dataFim: [null, null]
    });

    /* this.searchTyped
       .distinctUntilChanged()
       .filter((str: string) => str.length > 2 || str.length === 0)
       .subscribe(str =>
         this.service
           .obterEmpresas(str)
           .subscribe(itens => (this.items = itens.data))
       );*/

    this.loadChartsPie();
    this.loadResumo();
    this.loadEmpresaPorEstado();
    this.loadPontuacoesPorMes();
    this.loadPontuacoesPorAno();
    this.loadComparacoesDePontuacoePorAno();
    this.nameMonth = this.getMonth(new Date().getMonth() + 1);
    this.nameYaer = new Date().getFullYear();
    this.loadBestscustomers();
    this.loadComparacoesDeEmpresasCadastradaPorAno();


  }

  ngOnInit() {

  }
  loadChartsPie() {
    this.loader.show("body");
    this.service.obterPieCharts()
      .subscribe(itens => {
        this.loader.hide("body");
        this.piecharts = itens;
        this.initChartPie();
      });
  }
  loadResumo() {
    this.loader.show("body");

    this.service.obterTotalCliente()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_cliente = itens.total_cliente;
      });

    this.service.obterTotalClienteRecorrente()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_cliente_recorrente = itens.total_cliente_recorrente;
      });

    this.service.obterTotalClienteNaoRecorrente()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_cliente_naorecorrente = itens.total_cliente_naorecorrente;
      });

    this.service.obterTotalPontuacao()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_pontuacao = itens.total_pontuacao;
      });

    this.service.obterTotalCartaoIncompleto()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_cartao_incompleto = itens.total_cartao_incompleto;
      });

    this.service.obterProximosABonitificar()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_proximo_bonificar = itens.total_proximo_bonificar;
      });

    this.service.obterTotalCartao()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_cartao = itens.total_cartao;
      });

    this.service.obterTotalCartaoCompleto()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_cartao_completo = itens.total_cartao_completo;
      });

    this.service.obterFaturamentoAnual()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_faturamento_ano = itens.valor;
      });

    this.service.obterFaturamentoMes()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_faturamento_mes = itens.valor;
      });

    this.service.obterFaturamentoDia()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.total_faturamento_dia = itens.valor;
      });

    this.service.obterFaturamentoTicketMedioMes()
      .subscribe(itens => {
        this.loader.hide("body");
        this.resumo.ticket_medio_mensal = itens.valor;
      });


  }
  loadBestscustomers() {
    this.service.obterBestcustomers()
      .subscribe(itens => {
        this.bestscustomers = itens;
      });
  }
  loadPontuacoesPorMes() {
    this.service.obterPontuacoesPorDiaDoMes()
      .subscribe(itens => {
        this.pontuacoesPorMes = itens;
        this.initChartPontuacoesPorMes();
      });
  }

  loadPontuacoesPorAno() {
    this.service.obterPontuacoesPorAno()
      .subscribe(itens => {
        this.pontuacoesPorAno = itens;
        this.initChartPontuacoesPorAno();
      });
  }

  loadEmpresaPorEstado() {
    this.service.obterNovoClientesPorMes()
      .subscribe(itens => {
        this.empresasPorEstado = itens;
        this.initChartPiePorEstado();
      });
  }

  loadComparacoesDePontuacoePorAno() {
    this.service.obterComparacoesDePontuacoePorAno()
      .subscribe(itens => {
        this.comparacoesDePontuacoePorAno = itens;
        this.intCharComparacaoPontuacaoEntreAnos();
      });
  }

  loadComparacoesDeEmpresasCadastradaPorAno() {
    this.service.obterComparacaoDeEmperesasCadastradaPorAno()
      .subscribe(itens => {
        this.comparacaoDeEmperesasCadastradaPorAno = itens;
        this.intCharComparacaoEmpresasCadastradasPorAno();
      });
  }


  initChartPie() {
    this.piecharts.forEach(item => {
      this.pieData.labels.push(item.descricao);
      this.pieData.datasets[0].data.push(item.valor);
      this.pieColors[0].backgroundColor.push(item.cor);
      this.pieColors[0].borderColor.push(item.cor);
    });
  }

  initChartPiePorEstado() {
    var randomColor = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
    this.empresasPorEstado.forEach(item => {
      var randomColor = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
      var mes = this.meses[item.mes - 1];
      this.pieDataEmpresaPorEstado.labels.push(mes);
      this.pieDataEmpresaPorEstado.datasets[0].data.push(item.total);
      this.pieColorsEmpresaPorEstado[0].backgroundColor.push(randomColor);
      this.pieColorsEmpresaPorEstado[0].borderColor.push(randomColor);
    });
    var teste = this.charts;

    this.charts.forEach((child) => {
      child.chart.update();
    });
    /* setTimeout(() => {
       this.chatNovoClientes.refresh();
     }, 100);*/
    /*this.empresasPorEstado.forEach(item => {
      var randomColor = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
     var mes =  this.meses[item.mes-1];

      this.pieDataEmpresaPorEstado.labels.push(item.mes);
      this.pieDataEmpresaPorEstado.datasets[0].data.push(item.total);
      this.pieColorsEmpresaPorEstado[0].backgroundColor.push(randomColor);
      this.pieColorsEmpresaPorEstado[0].borderColor.push(randomColor);
    });*/
  }

  initChartPontuacoesPorMes() {
    this.barData = [{
      label: "Pontuacões por dia",
      color: "#FF375E",
      data: []
    }];
    this.pontuacoesPorMes.forEach(item => {
      this.barData[0].data.push([item.dia, item.total_pontuacao]);
    });
  }
  initChartPontuacoesPorAno() {
    this.barDataDotForYear = [{
      label: "Pontuacões por mês",
      color: "#4F008D",
      data: []
    }];
    this.pontuacoesPorAno.forEach(item => {
      this.barDataDotForYear[0].data.push([this.monthNames[item.mes - 1], item.total_pontuacao]);
    });
  }

  intCharComparacaoPontuacaoEntreAnos() {
    this.splineData = [{
      label: this.nameYaer,
      color: "#768294",
      data: []
    }, {
      label: this.nameYaer - 1,
      color: "#1f92fe",
      data: []
    }];

    this.comparacoesDePontuacoePorAno.anoAtual.forEach(item => {
      this.splineData[0].data.push([this.monthNames[item.mes - 1], item.total_pontuacao]);
    });

    this.comparacoesDePontuacoePorAno.anoPassado.forEach(item => {
      this.splineData[1].data.push([this.monthNames[item.mes - 1], item.total_pontuacao]);
    });
  }

  intCharComparacaoEmpresasCadastradasPorAno() {
    this.splineDataCompanyRegisterYaer = [{
      label: this.nameYaer,
      color: "#aad874",
      data: []
    }, {
      label: this.nameYaer - 1,
      color: "#7dc7df",
      data: []
    }];

    this.comparacaoDeEmperesasCadastradaPorAno.anoAtual.forEach(item => {
      this.splineDataCompanyRegisterYaer[0].data.push([this.monthNames[item.mes - 1], item.total]);
    });

    this.comparacaoDeEmperesasCadastradaPorAno.anoPassado.forEach(item => {
      this.splineDataCompanyRegisterYaer[1].data.push([this.monthNames[item.mes - 1], item.total]);
    });
  }

  getMonth(idx) {
    var objDate = new Date();
    objDate.setDate(1);
    objDate.setMonth(idx - 1);

    var locale = "pt-Br",
      month = objDate.toLocaleString(locale, { month: "long" });

    return month;
  }

}
